_ = require 'underscore'
t = require('views/internal/teacup-with-helpers')('list_menu')

module.exports = t.renderable ({ editable, subscribed, canCopyList, hasSortableCards, subscribeString, pluginActions, listLimitsEnabled }) ->
  t.ul '.pop-over-list', ->
    if editable
      t.li ->
        t.a '.js-add-card', { href: '#' }, ->
          t.format 'add-card-ellipsis'
      if canCopyList
        t.li ->
          t.a '.js-copy-list', { href: '#' }, ->
            t.format 'copy-list-ellipsis'
      t.li ->
        t.a '.js-move-list', { href: '#' }, ->
          t.format 'move-list-ellipsis'
    t.li ->
      t.a '.highlight-icon.js-list-subscribe', { href: '#' }, ->
        # EXPERIMENT: subscribeToWatchOrFollow
        t.check subscribed, subscribeString

  if editable

    if hasSortableCards
      t.hr()
      t.ul '.pop-over-list', ->
        t.li ->
          t.a '.js-sort-cards', { href: '#' }, ->
            t.format 'sort-by'

    if pluginActions?.length > 0
      t.hr()

      t.ul '.pop-over-list', ->
        pluginActions.map (action, index) ->
          t.li ->
            if _.isFunction(action.callback)
              t.a '.plugin-list-action.js-plugin-list-action', { href: '#', 'data-index': index, title: action.text }, ->
                t.span -> t.text action.text
                t.img {
                  src: action.icon
                  title: action.name
                  height: '18px'
                  width: '18px'
                }

    if listLimitsEnabled
      t.hr()
      t.ul '.pop-over-list', ->
        t.li ->
          t.a '.js-set-list-limit', { href: '#' }, ->
            t.format 'set-list-limit'

    t.hr()

    t.ul '.pop-over-list', ->
      t.li ->
        t.a '.js-move-cards', { href: '#' }, ->
          t.format 'move-all-cards-in-this-list-ellipsis'
      t.li ->
        t.a '.js-archive-cards', { href: '#' }, ->
          t.format 'archive-all-cards-in-this-list-ellipsis'

    t.hr()

    t.ul '.pop-over-list', ->
      t.li ->
        t.a '.js-close-list', { href: '#' }, ->
          t.format 'archive-this-list'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/list_menu.coffee